export default __webpack_public_path__ + "alberta-question.11219346c3d33cfbd688.svg";